/**
 * Type code mapping for two-pass parsing.
 * Maps 2-letter abbreviations to full question type names.
 */
export const TYPE_CODE_TO_FULL: Record<string, string> = {
  sc: 'single_choice',
  mc: 'multiple_choice',
  yn: 'yes_no',
  rs: 'rating_scale',
  ls: 'likert_scale',
  nps: 'nps',
  ni: 'numeric_input',
  mg: 'matrix_grid',
  mr: 'matrix_rating',
  rk: 'ranking',
  md: 'max_diff',
  cj: 'conjoint_analysis',
  st: 'short_text',
  lt: 'long_text',
  is: 'info_screen',
  dd: 'dropdown',
  ih: 'image_hotspot',
  pu: 'photo_upload',
};
